import React from "react";
import logodark from "../assest/logo-dark.png";
import kyc from "../assest/kyc-fail-logo.png";
import mailLogo from "../assest/mail-logo.png"
const KycFailed = () => {
  return (
    <div className="bg-screen d-flex align-items-center justify-content-center">
      <div className="text-center">
        {/* Logo */}
        <img
          src={logodark}
          alt="Logo"
          className="mb-4"
          style={{ width: "120px" }}
        />
        {/* KYC Verified Icon */}
        <div className="mb-3">
          <img src={kyc} alt="Logo" />
        </div>

        {/* Title */}
        <h5 className="">KYC Verification</h5>
        <h4 className="failed">Verification Failed</h4>

        {/* Message */}
        <p className="">Your identity verification was unsuccessful.</p>
        <p className="">
            Kindly contact the admin for verification.
        </p>
        <div className="d-flex align-items-center justify-content-center gap-2 email mt-3">
            <img src={mailLogo} alt="Logo" className="mb-0" />
            <a href="mailto:admin@yopmail.com" className="text-decoration-none">support@safeblocksolutions.com</a>
        </div>
      </div>
    </div>
  );
};

export default KycFailed;
